import authorizationSlice from './authorizationSlice';
import branchSlice from './branchSlice';
import clinicalSupervisorSlice from './clinicalSupervisorSlice';
import insuranceSlice from './insuranceSlice';
import userSlice from './userSlice';
import userSessionAllocationSlice from './userSessionAllocationSlice';

// Export all async thunks for backward compatibility
export { getAuthorizationTypes } from './authorizationSlice';
export { getUserBranches, addUserToBranches } from './branchSlice';
export {
	getClinicalSupervisorsTherapists,
	getClinicalSupervisorsBCBAs,
	getBCBAClinicalSupervisors,
	assignClinicalSupervisors,
	assignBcbas,
} from './clinicalSupervisorSlice';
export { getUserInsurances } from './insuranceSlice';
export {
	getUsers,
	getAdmins,
	getBCBAs,
	getBTs,
	getClinicalSupervisors,
	addUser,
	getUser,
	updateUser,
	deleteUser,
	saveUserBranches,
	updateSaveDisabled,
} from './userSlice';
export {
	getUserSessionAllocations,
	getUserSessionAllocation,
	createUserSessionAllocation,
	updateUserSessionAllocation,
	deleteUserSessionAllocation,
	getUserActiveAllocations,
	checkUserHasAllocation,
	getUserRemainingHours,
} from './userSessionAllocationSlice';

const User = {
	authorization: authorizationSlice,
	branch: branchSlice,
	clinicalSupervisor: clinicalSupervisorSlice,
	insurance: insuranceSlice,
	user: userSlice,
	userSessionAllocation: userSessionAllocationSlice,
};

export default User;
